import { render, staticRenderFns } from "./ModifySponsor.vue?vue&type=template&id=1e4f8e89"
import script from "./ModifySponsor.vue?vue&type=script&lang=js"
export * from "./ModifySponsor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports